import axios from "axios";

/**
 * Generic API POST request handler
 * @param {string} endpoint - API endpoint (e.g., '/ft/cookiescanner')
 * @param {object} payload - Data payload to send in request
 * @param {function} setLoading - Function to update loading state
 * @param {function} setToast - Function to show toast notifications
 * @returns {Promise<object|null>} API response data or null on error
 */
export const postDataToAPI = async (endpoint, payload, setLoading, setToast) => {
  const BASE_URL = "https://dev-platform2.portend.io/portend/v1/ft/"; // Base API URL

  try {
    setLoading(true);
    const response = await axios.post(`${BASE_URL}${endpoint}`, payload, {
      headers: { "Content-Type": "application/json" },
    });

    setToast({ open: true, message: "Request submitted successfully!", severity: "success" });
    return response.data;
  } catch (error) {
    console.error("API Request Failed:", error);
    setToast({ open: true, message: error.response?.data?.error || "Your request was not accepted. Please try again.", severity: "error" });
    return null;
  } finally {
    setLoading(false);
  }
};
